import React from 'react';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  resetPasswordLink: {
    display: 'flex',
    width: '100%',
    color: '#748CA0',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '&:before': {
      content: '""',
      borderTop: '1px solid #BECEDA',
      margin: '0 15px 0 0',
      flex: '1 0 15px'
    },
    '&:after': {
      content: '""',
      borderTop: '1px solid #BECEDA',
      margin: '0 0 0 15px',
      flex: '1 0 15px'
    }
  }
});

const LineOnSidesLink = ({ path, children }) => {
  const classes = useStyles();

  return (
    <Link to={path}>
      <Typography className={classes.resetPasswordLink} variant="body1">
        {children}
      </Typography>
    </Link>
  );
};

export default LineOnSidesLink;
